import React, {useRef} from "react";
import UserPageHeader from "../../Components/SendsUser/UserPageHeader";
import UserPageFooter from "../../Components/SendsUser/UserPageFooter";
import SendsHistoryControl from "../../Components/SendsAdmin/Controls/SendsHistoryControl";
import SendMailHistoryProvider from "../../Providers/SendMailHistoryProvider";
import { useAccountUser } from "@twigsby/client-data";

const UserSendsHistory = () => {
    const { data } = useAccountUser();
    const sendsHistoryRef = useRef<any>();

    return (
        <SendMailHistoryProvider userId={data?.id}>
                <div className='container' ref={sendsHistoryRef}>
                    <UserPageHeader />

                    <div className={'row mt-sm mb-xl'}>
                        <div className={'col-xs-12 col-center-lg-10 col-center-xl-8'}>
                            <div className={'card'}>
                                <SendsHistoryControl containerRef={sendsHistoryRef} forceHeader={true} />
                            </div>
                        </div>
                    </div>

                    <UserPageFooter />
                </div>
        </SendMailHistoryProvider>
    )
}

export default UserSendsHistory
